// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"cefc00be","790":"62699092"}[chunkId] + ".chunk.js";
};